import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UploadSurfaceTreatments = ClientInferResponseBody<
  typeof contract.companySettings.uploadCustomSurfaceTreatments,
  200
>;

export const uploadCustomSurfaceTreatments = async (
  companyId: string,
  file: File,
): Promise<UploadSurfaceTreatments> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.companySettings.uploadCustomSurfaceTreatments.mutation({
    params: { id: companyId },
    body: formData,
  });

  if (response.status === 200) {
    return response.body;
  }

  if (response.status === 400) {
    throw new ApiError(response.body.message, response.status, response.body);
  }

  throw new ApiError("Failed to upload surface treatments file", response.status, response.body);
};
